var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweetheartDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 17,
    viewBox: "0 0 59 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0232 15.1869C3.56432 16.513 5.84833 16.4419 7.34203 15.0527C13.0797 9.69308 20.7853 6.41732 29.2575 6.41732C37.7296 6.41732 45.4431 9.70097 51.1808 15.0606C52.6666 16.4498 54.9427 16.513 56.4838 15.1948L58.5149 13.4503C51.4495 5.21753 40.962 0 29.2575 0C17.5529 0 7.06542 5.21753 0 13.4503L2.03111 15.1869H2.0232Z",
    fill: "#71AD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetheartDown);
export default __webpack_public_path__ + "static/media/sweetheart_down.ed28300a33f4b467540fc939e269a4ed.svg";
export { ForwardRef as ReactComponent };